module.exports = __webpack_public_path__ + "static/media/012.687496c2.jpg";